import React from "react";
import { Modal } from "react-bootstrap";
import "./modalCustom.scss";

const ModalCustom = ({ show, handleClose, children }) => {
  return (
    <Modal
      backdrop={"static"}
      show={show}
      scrollable={true}
      onHide={handleClose}
      className="bottom-show-custom-modal"
      backdropClassName="modal-backdrop"
    >
      <Modal.Body className="p-0">{children}</Modal.Body>
    </Modal>
  );
};

export default ModalCustom;
